import { render, staticRenderFns } from "./McTable.vue?vue&type=template&id=224d8545"
import script from "./McTable.vue?vue&type=script&lang=js"
export * from "./McTable.vue?vue&type=script&lang=js"
import style0 from "./McTable.vue?vue&type=style&index=0&id=224d8545&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports